// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__dve9_","red":"Button_red__065V8","blue":"Button_blue__IOrj8","purple":"Button_purple__C9pbs","grey":"Button_grey__WWV6Q","simple":"Button_simple__ZCNPN"};